import React, { useEffect, useState } from "react";
import "./Best_seller.css";
import Common_heading from "../../common/common_heading/Common_heading";
import { useNavigate } from "react-router-dom";
import { Services } from "../../../utils/apis/service/Service";
import { IDS } from "../../../utils/common";
import Category_slider from "../category_slider/Category_slider";

// ✅ Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

function Best_seller() {
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);

  // ✅ default = null (show all)
  const [selectedProduct, setSelectedProduct] = useState(null);

  const getProducts = async () => {
    const res = await Services();

    if (res?.success) {
      setProducts(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  // ✅ Filter logic
  const filteredProducts = selectedProduct
    ? products.filter((p) => p.id === selectedProduct.id)
    : products;

  return (
    <section className="Best_seller">
      <div className="custom_container">
        <Common_heading
          heading={"Our Products"}
          subHeading={"CONSISTENT RELIABILITY FOR ANY INDUSTRY, ANY CHALLENGE."}
        />

        {/* ✅ Slider */}
        <Category_slider
          products={products}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
        />

        {/* ✅ Product Cards Swiper */}
        <div className="cards_holder">
          <Swiper
          className="pb-5"
            modules={[Autoplay]}
            spaceBetween={20}
            slidesPerView={4}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            breakpoints={{
              0: {
                slidesPerView: 2,
              },
              576: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1200: {
                slidesPerView: 4,
              },
            }}
          >
            {filteredProducts.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="product_cards_holder">
                  <div className="product_cards">
                    <div className="img_holder">
                      <img
                        src={IDS?.IMG_URL + item?.image}
                        alt={item?.name}
                        className="product_img"
                      />
                    </div>

                    <div className="hr_holder"></div>

                    <div className="product_name_holder">
                      <h3>{item?.name}</h3>
                    </div>
                  </div>

                  <div
                    className="view_more_holder"
                    onClick={() => navigate(`/explore-produtcs/${item.id}`)}
                  >
                    <p>View Product</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default Best_seller;
